import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";


export const getStandardOptionColumns = ({
    t,
    keyPrefix,
    i18n,
    apiRef,
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
        getValueForFilter: (rowData, extraData) => {
            let text = ""
            switch (extraData.fieldName) {
                case "noOfAttachments":
                    text = rowData.noOfAttachments != null ? rowData.noOfAttachments.toString() : "";
                    break;
                default:
                    text = rowData[extraData.fieldName]
                    break;
            }
            return text
        },
    })

    return [
        {
            field: "optionNo",
            headerName: t("buyersGuide.standardOptions.optionNumber"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.optionNo}
                        cellSubMenuOptions={{ options: getOptions({ field: "optionNo", isQuickFilterDisplay: rowData?.optionNo }), extraData: { fieldName: "optionNo", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "description",
            headerName: t("general.description"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.description}
                        cellSubMenuOptions={{ options: getOptions({ field: "description", isQuickFilterDisplay: rowData?.description }), extraData: { fieldName: "description", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "category",
            headerName: t("general.category"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.category}
                        cellSubMenuOptions={{ options: getOptions({ field: "category", isQuickFilterDisplay: rowData?.category }), extraData: { fieldName: "category", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "header",
            headerName: t("general.header"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.header}
                        cellSubMenuOptions={{ options: getOptions({ field: "header", isQuickFilterDisplay: Boolean(rowData?.header) }), extraData: { fieldName: "header", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "salesPriceExclVAT_Text",
            headerName: t("buyersGuide.standardOptions.salesPriceExclVAT"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.salesPriceExclVAT_Text}
                        cellSubMenuOptions={{ options: getOptions({ field: "salesPriceExclVAT_Text", isQuickFilterDisplay: Boolean(rowData?.salesPriceExclVAT_Text) }), extraData: { fieldName: "salesPriceExclVAT_Text", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "salesPriceInclVAT_Text",
            headerName: t("buyersGuide.standardOptions.salesPriceInclVAT"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.salesPriceInclVAT_Text}
                        cellSubMenuOptions={{ options: getOptions({ field: "salesPriceInclVAT_Text", isQuickFilterDisplay: Boolean(rowData?.salesPriceInclVAT_Text) }), extraData: { fieldName: "salesPriceInclVAT_Text", } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "noOfAttachments",
            headerName: t("buyersGuide.standardOptions.noOfAttachments"),
            flex: 1,
            sortable: 'true',
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.noOfAttachments}
                        cellSubMenuOptions={{ options: getOptions({ field: "noOfAttachments", isQuickFilterDisplay: Boolean(rowData?.noOfAttachments) }), extraData: { fieldName: "noOfAttachments", } }}
                        request={rowData}
                    />
                );
            },
        },
    ];
}